import { useEffect } from "react";
import image from "./../../styles/legacy/404.png";
import { NoContent } from "../components/NoContent";
import { useDispatch } from "react-redux";
import { logout } from "../redux/reducers/auth.reducer";
import eventHandler from "../utils/eventHandler";
import { forceCollapseLeftNavBarFixed } from "../redux/reducers/uiShared.reducer";
import { ROUTE_HOME } from "../utils/constants";
import { useNavigate } from "react-router";
import { useTopNavigationInfo } from "../hooks/useTopNavigationInfo";

export const LogOutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loadInfo, loadUserInfo } = useTopNavigationInfo();

  useEffect(() => {
    document.title = "The Hub - Log Out";
    dispatch(forceCollapseLeftNavBarFixed());
    dispatch(logout());
    localStorage.removeItem("hub_profile_cache");
  }, []);

  const LogIn = async () => {
    eventHandler.dispatch("authLogin", {});
    loadInfo(true);
    loadUserInfo();
    navigate(ROUTE_HOME);
  };

  return (
    <NoContent
      title="Logout Successful"
      text="You have been securely logged out of your account."
      action={() => LogIn()}
      image={image}
      style={{ margin: "3% auto 0 auto" }}
      textButton="Log in"
      conditionButton={true}
    />
  );
};
